import React from 'react'
import Public from '@/helpers/PageTypes/Public'
import SEO from '@/components/SEO'
import BackToTopButton from '@/components/BackToTopButton'
import FooterUnsigned from '@/components/LandingPageV2/Shared/Footer'
import Header from '@/components/LandingPageV2/Shared/Header'

interface LandingPageV2LayoutProps {
  children: React.ReactNode
  title: string
}

const LandingPageV2Layout = ({ children, title }: LandingPageV2LayoutProps) => {
  return (
    <Public>
      <SEO title={title} />
      <Header />
      {children}
      <FooterUnsigned />
      <BackToTopButton threshold={700} />
    </Public>
  )
}

export default LandingPageV2Layout
